import React, { useState, useEffect, useContext } from 'react'
import useDarkMode from 'use-dark-mode'
import styled from '@emotion/styled'
import './header.scss'
import { useTranslation } from 'react-i18next'
import { useQuery, useMutation } from 'react-apollo'
import { SET_ERROR } from 'graphql/mutations'
import GlobalState from '../../globalState'
import { connect, disconnect } from '../../api/web3modal'
import useNetworkInfo from '../NetworkInformation/useNetworkInfo'
import { mediaQueries } from 'devices'
import { useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import { Link as BaseLink } from 'react-router-dom'
import { Brightness2Outlined } from '@material-ui/icons'
import { MenuItem as BaseMenuItem } from '@material-ui/core'
import Logo from '../../assets/Images/Logo.png'
import { useLocale } from 'hooks'
import { KeyboardArrowDownOutlined } from '@material-ui/icons'
import { Select, FormControl } from '@material-ui/core'

function Header({ isMobileNav, setIsMobileNav }) {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const darkMode = useDarkMode(false)
  const { locale, setLocale } = useLocale()

  const navLinks = [
    {
      label: t('c.domains'),
      path: '/'
    },
    {
      label: t('c.account'),
      path: '/account'
    },
    {
      label: t('c.learn'),
      path: '/learn'
    },
    {
      label: t('c.faq'),
      path: '/faq'
    },
    {
      label: t('c.affliate'),
      path: '/affliate'
    },
    {
      label: t('c.contact'),
      path: '/contact'
    }
  ]

  const handeLocaleChange = e => {
    setLocale(e.target.value)
  }

  const { switchNetwork, currentNetwork } = useContext(GlobalState)
  const { accounts, network, loading, refetch, isReadOnly } = useNetworkInfo()

  const [setError] = useMutation(SET_ERROR)
  const handleConnect = async () => {
    setIsMobileNav(false)
    let network
    try {
      network = await connect()
    } catch (e) {
      setError({ variables: { message: e && e.message } })
    }
    if (network) {
      switchNetwork(network.chainId)
    }
    location.reload()
  }

  const handleDisconnect = async () => {
    setIsMobileNav(false)
    await disconnect()
    switchNetwork(1)
    location.reload()
  }

  const [selectedNav, setSelectedNav] = useState()

  const onToggleMobileNav = useCallback(() => {
    setIsMobileNav(!isMobileNav)
  }, [isMobileNav, setIsMobileNav])

  useEffect(() => {
    setSelectedNav(pathname)
  }, [pathname])

  const navigationPush = useCallback(
    path => {
      setSelectedNav(path)
      setIsMobileNav(false)
    },
    [setIsMobileNav]
  )

  const MenuProps = {
    PaperProps: {
      style: {
        marginTop: 40
      }
    }
  }
  return (
    // <header>
    //   <div className="headermainwidth desktopmenuview">
    //     <Grid container>
    //       <Grid container item xl={2} lg={2} md={2} sm={6} xs={6}>
    //         <img
    //           src={
    //             REACT_APP_STRAPI_API_URL + logo?.logo?.data[0]?.attributes?.url
    //           }
    //           alt="logo"
    //           className="img-responsive ML-10-MBL"
    //         />
    //       </Grid>
    //       <Grid container item xl={7} lg={6} md={5} sm={6} xs={6}>
    //         <ul className="navbar">
    //           <li>
    //             <a href="/">Domains</a>
    //           </li>
    //           {/* <li>
    //             <a href="/searchStart">Bulk</a>
    //           </li> */}
    //           {/* <li><a href="/avaxpricing">Bulk</a></li> */}
    //           <li>
    //             <a href="/learn">Learn</a>
    //           </li>
    //           <li>
    //             <a href="/faq">FAQ</a>
    //           </li>
    //           <li>
    //             <a href="/contact">Contact</a>
    //           </li>
    //         </ul>
    //         <div className="menu-toggle">
    //           <img src={Menuicon} alt=" " className="img-responsive" />
    //         </div>
    //       </Grid>
    //       <Grid container item xl={3} lg={4} md={5} sm={12} xs={12}>
    //         <div className="topright">
    //           <button
    //             className="connectbtn"
    //             onClick={isReadOnly ? handleConnect : handleDisconnect}
    //             style={{ cursor: 'pointer' }}
    //           >
    //             {isReadOnly ? t('c.connect') : t('c.disconnect')}
    //           </button>
    //           <select className="languagepicker" style={{ cursor: 'pointer' }}>
    //             <option>{t("c.english")}</option>
    //             <option>Español</option>
    //           </select>
    //           {/* <div className="carticon">
    //             <ShoppingCart />
    //           </div> */}
    //           <div
    //             className="themeicon"
    //             style={{
    //               display: 'flex',
    //               alignItems: 'center',
    //               justifyContent: 'center',
    //               marginLeft: 25,
    //               cursor: 'pointer'
    //             }}
    //           >
    //             <Brightness2Outlined onClick={darkMode.toggle} />
    //           </div>
    //         </div>
    //       </Grid>
    //     </Grid>
    //   </div>

    //   <div className="headermainwidth mobilemenuview">
    //     <Grid container>
    //       <Grid container item xl={2} lg={2} md={2} sm={6} xs={6}>
    //         <img
    //           src={
    //             REACT_APP_STRAPI_API_URL + logo?.logo?.data[0]?.attributes?.url
    //           }
    //           alt="logo"
    //           className="img-responsive ML-10-MBL"
    //         />
    //       </Grid>
    //       <Grid container item xl={7} lg={7} md={7} sm={6} xs={6}>
    //         <ul className="navbar">
    //           <li>
    //             <a href="/">Domains</a>
    //           </li>
    //           {/* <li><a href="/searchStart">Bulk</a></li> */}
    //           {/* <li>
    //             <a href="/avaxpricing">Bulk</a>
    //           </li> */}
    //           <li>
    //             <a href="/learn">Learn</a>
    //           </li>
    //           <li>
    //             <a href="/faq">FAQ</a>
    //           </li>
    //           <li>
    //             <a href="/contact">Contact</a>
    //           </li>
    //           <li className="TAC">
    //             <button className="connectbtn">Connect</button>
    //             <select className="languagepicker">
    //               <option>{t("c.english")}</option>
    //               <option>Español</option>
    //             </select>
    //           </li>
    //         </ul>
    //         {/* <div className="carticon">
    //           <ShoppingCart />
    //         </div> */}
    //         <div
    //           className="themeicon"
    //           style={{
    //             display: 'flex',
    //             alignItems: 'center',
    //             justifyContent: 'center'
    //           }}
    //         >
    //           <Brightness2Outlined onClick={darkMode.toggle} />
    //         </div>
    //         <div className="menu-toggle">
    //           <img src={Menuicon} alt=" " className="img-responsive" />
    //         </div>
    //       </Grid>
    //     </Grid>
    //   </div>
    // </header>
    <>
      <Wrapper className="header-primary">
        <div className="left">
          <BaseLink to="/">
            <img src={Logo} alt="logo" className="logo" />
          </BaseLink>
          <div className="showdesktop nav-items">
            {navLinks.map(item => (
              <div key={item.label}>
                <Link
                  key={item.label}
                  to={item.path}
                  onClick={() => navigationPush(item.path)}
                  active={selectedNav === item.path ? 'true' : undefined}
                  isdark={darkMode.value ? 'true' : undefined}
                >
                  {item.label}
                </Link>
              </div>
            ))}
          </div>
        </div>
        <div className="right">
          <Button
            onClick={isReadOnly ? handleConnect : handleDisconnect}
            style={{ cursor: 'pointer' }}
            className="btn showdesktop"
          >
            {isReadOnly ? t('c.connect') : t('c.disconnect')}
          </Button>
          <FormControl variant="outlined">
            <Select
              value={locale}
              onChange={handeLocaleChange}
              inputProps={{ 'aria-label': 'Without label' }}
              className="showdesktop select"
              style={{
                fontSize: '14px'
              }}
              MenuProps={MenuProps}
              IconComponent={KeyboardArrowDownOutlined}
            >
              <MenuItem value="en">{t('c.english')}</MenuItem>
              <MenuItem value="vi">{t('c.vietnamese')}</MenuItem>
            </Select>
          </FormControl>
          <Brightness2Outlined
            className="mode-icon dark-secondary"
            onClick={darkMode.toggle}
            style={{ cursor: 'pointer' }}
          />
          <ToggleIcon
            onClick={onToggleMobileNav}
            ismobilenav={isMobileNav}
            isdark={darkMode.value}
          />
        </div>
      </Wrapper>
      <MobileNav isMobileNav={isMobileNav}>
        {navLinks.map(item => (
          <div className="mobile-links" key={item.label}>
            <Link
              key={item.label}
              to={item.path}
              onClick={() => navigationPush(item.path)}
              active={selectedNav === item.path ? 'true' : undefined}
              isdark={darkMode.value ? 'true' : undefined}
            >
              {item.label}
            </Link>
          </div>
        ))}
        <div className="mobile-foot">
          <Button
            onClick={isReadOnly ? handleConnect : handleDisconnect}
            style={{ cursor: 'pointer', background: '#e7303c' }}
            className="btn"
          >
            {isReadOnly ? t('c.connect') : t('c.disconnect')}
          </Button>
          <FormControl variant="outlined">
            <Select
              value={locale}
              onChange={handeLocaleChange}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              className="select-mobile"
              IconComponent={KeyboardArrowDownOutlined}
              MenuProps={MenuProps}
            >
              <MenuItem value="en">{t('c.english')}</MenuItem>
              <MenuItem value="vi">{t('c.vietnamese')}</MenuItem>
            </Select>
          </FormControl>
        </div>
      </MobileNav>
    </>
  )
}
export default Header

const Wrapper = styled('header')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding: 23px 80px;
  .logo {
    max-width: 140px;
    height: auto;
  }
  ${mediaQueries.tabland} {
    padding: 23px 20px;

    btn {
      max-width: 10px;
    }
  }
  ${mediaQueries.tabport} {
    padding: 23px 20px;
  }
  ${mediaQueries.phone} {
    .logo {
      max-width: 100%;
    }
  }
  .left {
    display: flex;
  }
  .right {
    display: flex;
    align-items: center;
    gap: 30px;
    ${mediaQueries.tabland} {
      gap: 15px;
    }
  }
  .nav-items {
    display: flex;
    align-items: center;
    > * {
      margin-left: 30px;
      ${mediaQueries.tabland} {
        margin-left: 15px;
      }
    }
  }
  svg {
    max-width: 100%;
    height: auto;
  }
  .showdesktop {
    ${mediaQueries.tabport} {
      display: none;
    }
  }
`

const Button = styled('button')`
  background: #121212;
  color: #fff;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 2;
  padding: 11.55px 50px;
  border: none;
  ${mediaQueries.tabland} {
    padding: 10px 25px;
    font-size: 11px;
  }
  ${mediaQueries.tabport} {
    font-size: 14px;
    padding: 10px 60px;
  }
`

const MobileNav = styled('div')`
  left: 0px;
  position: absolute;
  top: 70px;
  z-index: 5;
  width: 100%;
  background: #0f0e1e;
  padding: 40px;
  gap: 20px;
  flex-direction: column;
  transition: all 1s;
  transform: translateX(-1000px);
  visibility: hidden;
  display: flex;
  margin-top: 20px;
  background: black;
  padding-bottom: 100px;
  .mobile-links {
    border-bottom: 1px solid #181818;
    padding: 20px 0px;
    cursor: pointer;
  }
  .mobile-foot {
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
  }
  ${mediaQueries.tabport} {
    transform: ${({ isMobileNav }) => (isMobileNav ? 'translateX(0px)' : '')};
    visibility: ${({ isMobileNav }) => (isMobileNav ? 'visible' : 'hidden')};
    a {
      font-size: 25px;
    }
  }
`

const ToggleIcon = styled('div')`
  position: relative;
  opacity: 1;
  margin-right: 20px;
  &,
  &::before,
  &::after {
    width: 20px;
    height: 2px;
    z-index: 1200;
    display: none;
    ${mediaQueries.tabport} {
      display: inline-block;
      background-color: ${({ isdark }) => (isdark ? '#ffffff' : '#181818')};
    }
  }
  & {
    background-color: ${({ ismobilenav, isdark }) =>
      ismobilenav ? 'transparent' : isdark ? '#ffffff' : '#181818'};
  }
  &::before,
  &::after {
    content: '';
    position: absolute;
    transition: all 0.2s;
  }
  &::before {
    top: ${({ ismobilenav }) => (ismobilenav ? '0' : '-8px')};
    transform: ${({ ismobilenav }) => (ismobilenav ? 'rotate(135deg)' : '')};
  }
  &::after {
    top: ${({ ismobilenav }) => (ismobilenav ? '0' : '8px')};
    transform: ${({ ismobilenav }) => (ismobilenav ? 'rotate(-135deg)' : '')};
  }
`

const Link = styled(BaseLink)`
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  color: ${({ active, isdark }) =>
    active ? '#e7303c' : isdark ? '#fff' : '#181818'};
  ${mediaQueries.tabport} {
    color: ${({ active }) => (active ? '#e7303c' : '#ffffff')};
  }
  ${mediaQueries.tabland} {
    font-weight: 15px;
  }
`

const MenuItem = styled(BaseMenuItem)`
  font-size: 12px !important;
`
